module.exports = __webpack_public_path__ + "c89a2fc0fce33e78fc23139ab5dcad6b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MG.svg
// module id = 6hOU
// module chunks = 0